import {IServiceFactory} from "../../service-factory.interface";
import {
    ISendElasticEventOptions,
    OrbitMarketingEventAnalyticsCategory } from "../../analytics/analytics.service.interface";

export function onToastButtonClickedAnalytics(services: IServiceFactory, toastId: string | number) {
    const cid = services.user.cid || 'annonymous';
    let data: ISendElasticEventOptions = {
        eventType: "Orbit_Marketing",
        category: 'Communications',
        action: toastId + '_CTA_Click',
        label: cid + '_' + Date.now().toString(),
    };
    services.analytics.sendElasticInfoEvent(data, true);
    services.analytics.sendOrbitMarketingEvent(OrbitMarketingEventAnalyticsCategory.Communications, toastId + '_CTA_Click', cid + '_' + Date.now().toString());
}

export function onToastOpenedAnalytics(services: IServiceFactory, toastId: string | number) {
    const cid = services.user.cid || 'annonymous';
    services.analytics.sendOrbitMarketingEvent(OrbitMarketingEventAnalyticsCategory.Communications, toastId + '_Show', cid + '_' + Date.now().toString());
}